module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-pers",
    class: {
      '-fixed-height-box': _vm.pcDisp
    },
    attrs: {
      "id": "pers-tab19",
      "name": "hres31x-tab19"
    }
  }, [_c('div', {
    staticClass: "sub-topic-box color-skin",
    on: {
      "click": _vm.toggleSubTopic1
    }
  }, [_c('i', {
    staticClass: "fa fa-users icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRES31XC1']['460']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic1),
      expression: "subTopic1"
    }],
    staticClass: "data-pers-box"
  }, [_vm._l((_vm.detail.tableEtcData.rows), function(value, index) {
    return [_c('div', {
      staticClass: "row data-box"
    }, [_c('div', {
      staticClass: "col-xs-6 data-label"
    }, [_vm._v(_vm._s(value.desother))]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6 data-text"
    }, [_vm._v(_vm._s(value.desvalue))])])]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1583c029!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres31x/tab19.vue
// module id = 3585
// module chunks = 1